import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-darker py-8 border-t border-gray-800" data-id="element-52">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-4" data-id="element-53">
          <p className="text-gray-500 text-sm" data-id="element-54">
            © {new Date().getFullYear()} Batidos de Energía 7x7. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-55">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-brand-green text-sm transition-colors underline underline-offset-2" data-id="element-56">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-brand-green text-sm transition-colors underline underline-offset-2" data-id="element-57">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-58">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-59">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-darker border border-gray-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-60">
              <div className="sticky top-0 bg-darker border-b border-gray-700 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-61">
                <h2 className="font-serif text-xl font-bold text-white" data-id="element-62">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-gray-800" aria-label="Cerrar" data-id="element-63">
                  <XIcon className="w-5 h-5" data-id="element-64" />
                </button>
              </div>

              <div className="px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-65">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-66" /> : <TermsContent data-id="element-67" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-68">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-white font-semibold text-base mt-2" data-id="element-69">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-70">
        Recopilamos información personal que nos proporcionas voluntariamente al
        realizar una compra o suscribirte a nuestro contenido, incluyendo:
        nombre, dirección de correo electrónico e información de pago.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-71">
        2. Uso de la Información
      </h3>
      <p data-id="element-72">Utilizamos tu información para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-73">
        <li data-id="element-74">Procesar y entregar tu compra de productos digitales.</li>
        <li data-id="element-75">Enviarte actualizaciones relacionadas con tu pedido.</li>
        <li data-id="element-76">Mejorar nuestros productos y servicios.</li>
        <li data-id="element-77">
          Comunicarnos contigo sobre ofertas relevantes (solo con tu
          consentimiento).
        </li>
      </ul>

      <h3 className="text-white font-semibold text-base" data-id="element-78">
        3. Protección de Datos
      </h3>
      <p data-id="element-79">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-80">
        4. Compartir Información
      </h3>
      <p data-id="element-81">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto proveedores de servicios necesarios para procesar
        pagos y entregar productos.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-82">5. Cookies</h3>
      <p data-id="element-83">
        Utilizamos cookies para mejorar tu experiencia de navegación y analizar
        el tráfico del sitio. Puedes configurar tu navegador para rechazar
        cookies.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-84">6. Tus Derechos</h3>
      <p data-id="element-85">
        Tienes derecho a acceder, rectificar, eliminar o limitar el
        procesamiento de tus datos personales en cualquier momento.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-86">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-white font-semibold text-base mt-2" data-id="element-87">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-88">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, aceptas cumplir con estos términos y condiciones en su
        totalidad.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-89">
        2. Productos Digitales
      </h3>
      <p data-id="element-90">
        Los productos ofrecidos son guías digitales descargables con recetas de
        batidos. El contenido es informativo y no sustituye el consejo médico
        profesional.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-91">3. Uso Personal</h3>
      <p data-id="element-92">
        Los productos adquiridos son para uso personal exclusivamente. Queda
        prohibida la reproducción, distribución o reventa del contenido sin
        autorización expresa.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-93">
        4. Política de Reembolso
      </h3>
      <p data-id="element-94">
        Debido a la naturaleza digital de nuestros productos, todas las ventas
        son finales. Sin embargo, si experimentas problemas técnicos para
        acceder al contenido, nos comprometemos a resolverlos.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-95">
        5. Descargo de Responsabilidad
      </h3>
      <p data-id="element-96">
        La información proporcionada en nuestros productos es de carácter
        general y educativo. Los resultados pueden variar según cada persona.
        Consulta con un profesional de salud antes de realizar cambios
        significativos en tu dieta.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-97">
        6. Propiedad Intelectual
      </h3>
      <p data-id="element-98">
        Todo el contenido, incluyendo textos, imágenes, diseños y recetas, está
        protegido por derechos de autor y es propiedad exclusiva de Batidos de
        Energía 7x7.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-99">7. Modificaciones</h3>
      <p data-id="element-100">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio.
      </p>
    </>;
}